module.exports = __webpack_public_path__ + "img/PL00167.78d11af7.png";